<template>
  <ion-menu side="end" type="overlay" content-id="main-content">
    <!--menu header start-->
    <ion-header class="menu-header-container">
      <ion-toolbar class="menu-header-toolbar">
        <ion-buttons slot="start">
          <ion-menu-toggle>
            <ion-button fill="clear" class="menu-back-button">
              <ion-icon
                slot="icon-only"
                :icon="chevronBack"
                class="menu-back-icon"
              ></ion-icon>
            </ion-button>
          </ion-menu-toggle>
        </ion-buttons>
        <ion-title class="menu-page-title">Account</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-row class="user-info-row" v-if="isLoggedIn">
        <ion-col size="3">
          <ion-avatar class="avatar-menu">
            <img src="assets/placeholders/avatar.png" />
          </ion-avatar>
        </ion-col>
        <ion-col size="7">
          <span class="name-menu">
            {{ fullName || "Guest" }}
          </span>
          <span class="edit-menu"
            ><!--<a href="/profile">Edit profile</a>-->
          </span>
        </ion-col>
      </ion-row>
      <ion-list>
        <div
          class="sidemenu"
          v-if="isLoggedIn"
          role="button"
          tabindex="0"
          aria-label="Navigate to Favorites"
          @click="navigateTo('/favorites')"
          @keydown.enter="navigateTo('/favorites')"
          @keydown.space.prevent="navigateTo('/favorites')"
        >
          <ion-row>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/lovely-menu.svg" />
            </ion-col>
            <ion-col size="10" class="ion-padding-start">
              <span class="menu-link">Favorites</span>
            </ion-col>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
            </ion-col>
          </ion-row>
        </div>
        <div
          class="sidemenu"
          v-if="isLoggedIn"
          role="button"
          tabindex="0"
          aria-label="Navigate to Rewards and Promotions"
          @click="navigateTo('/rewards')"
          @keydown.enter="navigateTo('/rewards')"
          @keydown.space.prevent="navigateTo('/rewards')"
        >
          <ion-row>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/ticket-menu.svg" />
            </ion-col>
            <ion-col size="10" class="ion-padding-start">
              <span class="menu-link">Rewards and Promotions</span>
            </ion-col>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
            </ion-col>
          </ion-row>
        </div>
        <div
          class="sidemenu"
          v-if="isLoggedIn"
          role="button"
          tabindex="0"
          aria-label="Navigate to Order History"
          @click="navigateTo('/order-history')"
          @keydown.enter="navigateTo('/order-history')"
          @keydown.space.prevent="navigateTo('/order-history')"
        >
          <ion-row>
            <ion-col size="1">
              <ion-icon
                class="list-icon"
                src="assets/icon/receipt-minus-menu.svg"
              />
            </ion-col>
            <ion-col size="10" class="ion-padding-start">
              <span class="menu-link">Order History</span>
            </ion-col>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
            </ion-col>
          </ion-row>
        </div>
        <div
          class="sidemenu"
          role="button"
          tabindex="0"
          aria-label="Navigate to Support Center"
          @click="navigateTo('/support')"
          @keydown.enter="navigateTo('/support')"
          @keydown.space.prevent="navigateTo('/support')"
        >
          <ion-row>
            <ion-col size="1">
              <ion-icon
                class="list-icon"
                src="assets/icon/message-question-menu.svg"
              />
            </ion-col>
            <ion-col size="10" class="ion-padding-start">
              <span class="menu-link">Support Center</span>
            </ion-col>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
            </ion-col>
          </ion-row>
        </div>
        <div
          class="sidemenu"
          v-if="isLoggedIn"
          role="button"
          tabindex="0"
          aria-label="Navigate to Request Account Deletion"
          @click="navigateTo('/account-deletion')"
          @keydown.enter="navigateTo('/account-deletion')"
          @keydown.space.prevent="navigateTo('/account-deletion')"
        >
          <ion-row>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/close-circle.svg" />
            </ion-col>
            <ion-col size="10" class="ion-padding-start">
              <span class="menu-link">Request Account Deletion</span>
            </ion-col>
            <ion-col size="1">
              <ion-icon class="list-icon" src="assets/icon/arrow-right.svg" />
            </ion-col>
          </ion-row>
        </div>
      </ion-list>
    </ion-content>
    <div align="center" class="logout-menu padbot-logout">
      <a
        role="button"
        tabindex="0"
        @click="logout"
        @keydown.enter="logout"
        @keydown.space.prevent="logout"
        v-if="isLoggedIn"
      >
        Sign Out
      </a>
      <a
        role="button"
        tabindex="0"
        @click="signIn"
        @keydown.enter="signIn"
        @keydown.space.prevent="signIn"
        v-else
      >
        Sign In
      </a>
    </div>
  </ion-menu>
</template>

<script>
import { defineComponent } from "vue";
import { chevronBack } from "ionicons/icons";
import {
  IonContent,
  IonHeader,
  IonMenuToggle,
  IonButtons,
  IonButton,
  IonList,
  IonIcon,
  IonToolbar,
  IonMenu,
  IonRow,
  IonCol,
  IonAvatar,
  IonTitle,
  alertController,
  menuController,
} from "@ionic/vue";

export default defineComponent({
  name: "TheSideMenu",
  components: {
    IonContent,
    IonHeader,
    IonMenuToggle,
    IonButtons,
    IonButton,
    IonList,
    IonIcon,
    IonToolbar,
    IonMenu,
    IonRow,
    IonCol,
    IonAvatar,
    IonTitle,
  },
  setup() {
    return {
      chevronBack,
    };
  },
  data() {
    const storedName = localStorage.getItem("name");
    return {
      promptMessage: "",
      fullName: storedName && storedName !== "null" ? storedName : null,
    };
  },
  computed: {
    isLoggedIn() {
      const token = localStorage.getItem("token");
      return token !== null && token !== "null" && token !== "";
    },
  },
  methods: {
    async navigateTo(path) {
      try {
        // Close menu first
        await menuController.close();

        // Check if already on the target path after menu closes
        if (this.$route.path === path) {
          return;
        }

        // Navigate to the path
        await this.$router.push(path);
      } catch (err) {
        // Ignore navigation duplicated errors
        if (err && err.name !== "NavigationDuplicated") {
          console.error("Navigation error:", err.name);
        }
      }
    },
    async presentAlert() {
      const alert = await alertController.create({
        message: this.promptMessage,
        buttons: [
          {
            text: "No",
            role: "cancel",
            handler: () => {},
          },
          {
            text: "Yes",
            role: "confirm",
            handler: () => {
              this.onConfirmOK();
            },
          },
        ],
      });

      await alert.present();
      await alert.onDidDismiss();
    },
    async signIn() {
      try {
        console.log("=== Sign In Clicked ===");
        console.log("Current token:", localStorage.getItem("token"));
        console.log("Current userType:", localStorage.getItem("userType"));
        console.log("Current isVerified:", localStorage.getItem("isVerified"));
        console.log("isLoggedIn:", this.isLoggedIn);

        // Close menu first
        await menuController.close();
        console.log("Menu closed, navigating to /welcome");

        // Use window.location for navigation to ensure it works
        window.location.href = "/welcome";
      } catch (err) {
        console.error("Sign in navigation error:", err);
      }
    },
    async logout() {
      this.promptMessage = "Are you sure you want to logout?";
      await this.presentAlert();
    },
    onConfirmOK() {
      // Clear Vuex store state
      this.$store.commit("clearStore");

      // Selectively remove auth-related keys instead of clearing all storage
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      localStorage.removeItem("id");
      localStorage.removeItem("cafeId");
      localStorage.removeItem("userType");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("isVerified");
      window.location.href = "/userlogin";
    },
  },
});
</script>

<style scoped>
/* Menu Styles */
ion-menu {
  --width: 100%;
}
.sidemenu {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  color: #1b1b1b;
  font-size: 14px;
  padding-top: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f3f3f3;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  position: relative;
  user-select: none;
}
.sidemenu:active {
  background-color: #f9f9f9;
}
.sidemenu:focus {
  outline: 2px solid #f87e63;
  outline-offset: 2px;
}
.sidemenu a,
.sidemenu .menu-link {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  color: #1b1b1b;
  font-size: 14px;
  text-decoration: none;
  width: 100%;
  display: inline-block;
  position: relative;
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
}
/* Menu Header Styling */
.menu-header-container {
  --background: #f87e63;
}

.menu-header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.menu-page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.menu-back-button {
  --padding-start: 0;
  --padding-end: 0;
  margin: 0;
}

.menu-back-icon {
  color: #ffffff;
  font-size: 24px;
}

.user-info-row {
  padding: 20px 0;
  border-bottom: 1px solid #f3f3f3;
}

.name-menu {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  color: #1b1b1b;
  display: block;
  margin-top: 20px;
}
.edit-menu a {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 135%;
  color: #ababab;
  display: block;
  margin-top: 5px;
  text-decoration: none;
}
.avatar-menu {
  margin-left: 10%;
}
.logout-menu {
  position: relative;
  z-index: 10;
}
.logout-menu a {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #f87e63;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  padding: 10px 20px;
  position: relative;
  z-index: 10;
  pointer-events: auto;
  user-select: none;
}
.padbot-logout {
  padding-bottom: 32px;
}
.list-icon {
  width: 14px;
}
</style>
